export const MODULE_TYPES = {
  INFO: 'info',
  PRODUCT: 'product',
  GALLERY: 'gallery',
  CTA: 'cta',
  PRINT_PAL: 'printPal',
};

export const MODULE_TYPE_LABELS = {
  [MODULE_TYPES.INFO]: 'Info Module',
  [MODULE_TYPES.PRODUCT]: 'Product Module',
  [MODULE_TYPES.GALLERY]: 'Photo Gallery Module',
  [MODULE_TYPES.CTA]: 'Call to Action Module',
  [MODULE_TYPES.PRINT_PAL]: 'Print Pal',
};
